import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=39c5001b&scoped=true&"
import script from "./sso.vue?vue&type=script&lang=js&"
export * from "./sso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c5001b",
  null
  
)

export default component.exports